export enum TimelineDaysPreset {
  WEEKDAYS = 'weekdays',
  WEEKEND = 'weekend',
  COMPLETE_WEEK = 'completeWeek',
}
